import { useTranslations } from "@/contexts/Translation";
import { useNavigate } from "react-router-dom";
import CreateLink from "../CreateLink/CreateLink";
import styles from "./CreateImprovementGoalLink.module.css";

type ComponentProps = {
  surveyId: string;
  text?: string;
};

export const CreateImprovementGoalLink = ({ surveyId, text }: ComponentProps) => {
  const t = useTranslations("improvementGoals");
  const navigate = useNavigate();

  const createGoal = () => {
    navigate(`/improvement?fromSurvey=${surveyId}`);
    window.scrollTo(0, 0);
  };

  return (
    <div className={styles.root}>
      <CreateLink createFn={createGoal} text={text || t("create")} />
    </div>
  );
};
